import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, VStack, Text, Button, Icon, HStack, Tag, Img, useDisclosure, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Image, } from "@chakra-ui/react";
import { AtSignIcon } from "@chakra-ui/icons";
import { FaFemale } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { addMinutes, format } from "date-fns";
import { isTimeSlotWithinBuffer } from "../helpers/bookingAvailability";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import TableArea from "../components/tables/TableArea";
import { roundToNearest60 } from "../shared-utils/utils";
import { tablePerksIcons } from "../shared-utils/values";
import React from "react";
import { IMG_URL } from "../components/common/Constant";
import { useCustomToast } from "../components/useCustomToast";
import ResponsiveModal from "../components/common/ResponsiveModal";
import PassSelectionCard from "../components/tables/PassSelectionCard";
import FastTrackEntryInfoCard from "../components/event/FastTrackEntryInfoCard";
import TableAreaOld from "../components/tables/TableAreaOld";
export default function EventTableBooking({ event }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const navigate = useNavigate();
    const location = useLocation();
    const customToast = useCustomToast();
    const { eventId } = useParams();
    const [showButtonAnimation, setShowButtonAnimation] = useState(true);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState();
    const [maleCount, setMaleCount] = useState(0);
    const [femaleCount, setFemaleCount] = useState(0);
    const [currentStep, setCurrentStep] = useState(1);
    const [timeSlots, setTimeSlots] = useState([]);
    const [selectedTime, setSelectedTime] = useState();
    const [selectedTable, setSelectedTable] = useState();
    const [requirementMessage, setRequirementMessage] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
    const [shouldShakeCounters, setShouldShakeCounters] = useState(false);
    const isTimeChangeInProgress = React.useRef(false);
    const uniqueDates = Array.from(new Set(timeSlots.map((slot) => slot.date)));
    const filteredSlots = timeSlots.filter((slot) => slot.date === selectedDate);
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const day = date.toLocaleDateString("en-US", { weekday: "short" });
        const dayNum = date.getDate();
        const month = date.toLocaleDateString("en-US", { month: "short" });
        return { day, dayNum, month };
    };
    useEffect(() => {
        if (event) {
            const timeSlotsList = [];
            // Handle direct slots
            if (event.direct_slots) {
                event.direct_slots.forEach((slot, index) => {
                    // Check if slot has ended
                    timeSlotsList.push(...generateTimeSlots(slot, slot.id));
                });
            }
            // Handle sub events slots
            if (event.has_sub_events && event.sub_events) {
                event.sub_events.forEach((subEvent) => {
                    if (subEvent.slots) {
                        subEvent.slots.forEach((slot, index) => {
                            // Check if slot has ended
                            timeSlotsList.push(...generateTimeSlots(slot, slot.id));
                        });
                    }
                });
            }
            setTimeSlots(timeSlotsList);
        }
    }, [event]);
    useEffect(() => {
        if (filteredSlots.length > 0 && selectedTime) {
            // Parse selectedTime to Date object
            let selectedDateTime;
            if (selectedTime.includes("T")) {
                selectedDateTime = new Date(selectedTime);
            }
            else {
                // Parse "yyyy/MM/dd h:mm a" format
                const [datePart, ...timeParts] = selectedTime.split(" ");
                const timeStr = timeParts.join(" ");
                const [year, month, day] = datePart.split("/").map(Number);
                const dateStr = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                selectedDateTime = new Date(`${dateStr} ${timeStr}`);
            }
            // Get first and last slot times
            const firstSlot = filteredSlots[0];
            const lastSlot = filteredSlots[filteredSlots.length - 1];
            const parseSlotToDate = (slot) => {
                const [year, month, day] = slot.date.split("/").map(Number);
                const dateStr = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
                return new Date(`${dateStr} ${slot.time}`);
            };
            const firstSlotTime = parseSlotToDate(firstSlot);
            const lastSlotTime = parseSlotToDate(lastSlot);
            // Check if selected time falls between first and last slot
            const isWithinRange = selectedDateTime >= firstSlotTime && selectedDateTime <= lastSlotTime;
            if (!isWithinRange) {
                const defaultTime = `${firstSlot.date} ${firstSlot.time}`;
                setSelectedTime(defaultTime);
                setSelectedTimeSlot(firstSlot.slotId);
            }
        }
    }, [selectedDate]);
    useEffect(() => {
        if (uniqueDates.length > 0 && !selectedDate) {
            setSelectedDate(uniqueDates[0]);
        }
    }, [uniqueDates]);
    useEffect(() => {
        if (isTimeChangeInProgress.current)
            return;
        const searchParams = new URLSearchParams(location.search);
        const step = searchParams.get("step");
        const timeSlot = searchParams.get("slot");
        const time = searchParams.get("time");
        const male_count = searchParams.get("male-count");
        const female_count = searchParams.get("female-count");
        if (step) {
            setCurrentStep(parseInt(step));
            if (timeSlot)
                setSelectedTimeSlot(parseInt(timeSlot));
            if (time)
                setSelectedTime(time);
            if (male_count)
                setMaleCount(parseInt(male_count));
            if (female_count)
                setFemaleCount(parseInt(female_count));
            const localSelectedTable = localStorage.getItem(`z_selected_table_${eventId}`);
            if (localSelectedTable && !selectedTable)
                setSelectedTable(JSON.parse(localSelectedTable));
        }
        else
            setCurrentStep(1);
    }, [location]);
    useEffect(() => {
        if (selectedTime && (maleCount || femaleCount)) {
            setTimeout(() => {
                setShowButtonAnimation(false);
            }, 50);
        }
        else
            setShowButtonAnimation(true);
    }, [selectedTime, maleCount, femaleCount]);
    // Clear requirement message when female count meets the requirement
    useEffect(() => {
        if ((selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.minLadiesRequired) &&
            femaleCount >= (selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.minLadiesRequired)) {
            setRequirementMessage("");
        }
    }, [femaleCount, selectedTable]);
    const onNextStep = () => {
        if (selectedTime) {
            setCurrentStep(2);
            navigate(`?step=2&slot=${selectedTimeSlot}&time=${selectedTime}&male-count=${maleCount}&female-count=${femaleCount}`);
        }
    };
    // Handle table selection with female requirement validation
    const handleTableSelectOld = (table) => {
        if (!table) {
            setSelectedTable(null);
            setRequirementMessage("");
            return;
        }
        setSelectedTable(table);
        const payload = {
            ...table,
            time: selectedTime,
        };
        localStorage.setItem(`z_selected_table_${eventId}`, JSON.stringify(payload));
        setIsBottomSheetOpen(true);
        if (table.minLadiesRequired && femaleCount < table.minLadiesRequired) {
            setRequirementMessage(`This table requires at least ${table.minLadiesRequired} females in the group`);
        }
        else {
            setRequirementMessage("");
        }
    };
    const handleTableSelect = (table) => {
        if (!table)
            return;
        setSelectedTable(table);
        const payload = {
            ...table,
            time: selectedTime,
        };
        localStorage.setItem(`z_selected_table_${eventId}`, JSON.stringify(payload));
        onConfirmTable(payload);
    };
    // Check if table is disabled due to female requirements
    const isTableDisabled = () => {
        if (!(selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.isNewTableFormat) &&
            (selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.minLadiesRequired) &&
            femaleCount < selectedTable.minLadiesRequired) {
            return true;
        }
        return false;
    };
    // Check if continue button should be disabled
    const isButtonDisabled = () => {
        if (!(selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.isNewTableFormat) &&
            (selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.minLadiesRequired) &&
            femaleCount < selectedTable.minLadiesRequired) {
            return true;
        }
        return false;
    };
    const generateTimeSlots = (slot, id) => {
        const { start_time, end_time } = slot;
        const startDate = new Date(start_time);
        const endDate = new Date(end_time);
        const timeSlots = [];
        let currentTime = roundToNearest60(new Date());
        currentTime = currentTime >= startDate ? currentTime : startDate;
        // Get buffer time from event
        const bufferMinutes = (event === null || event === void 0 ? void 0 : event.buffer_time_minutes) || 0;
        while (currentTime <= endDate) {
            // Check if this time slot is within buffer time
            if (isTimeSlotWithinBuffer(currentTime, bufferMinutes)) {
                timeSlots.push({
                    time: format(currentTime, "h:mm a"),
                    date: format(currentTime, "yyyy/MM/dd"),
                    slotId: id,
                });
            }
            currentTime = addMinutes(currentTime, 60);
        }
        return timeSlots;
    };
    const handleTimeChange = (newTime, newMaleCount, newFemaleCount) => {
        setSelectedTime(newTime);
        setMaleCount(newMaleCount);
        setFemaleCount(newFemaleCount);
        let matchingSlot = timeSlots.find((slot) => {
            const slotDateTime = `${slot.date} ${slot.time}`;
            return slotDateTime === newTime;
        });
        if (!matchingSlot && newTime.includes("T")) {
            const parsedNew = new Date(newTime);
            if (!isNaN(parsedNew.getTime())) {
                matchingSlot = timeSlots.find((slot) => {
                    const [y, mo, d] = slot.date.split("/").map(Number);
                    const slotDate = new Date(`${y}-${String(mo).padStart(2, "0")}-${String(d).padStart(2, "0")} ${slot.time}`);
                    return (!isNaN(slotDate.getTime()) &&
                        format(slotDate, "yyyy-MM-dd'T'HH:mm") ===
                            format(parsedNew, "yyyy-MM-dd'T'HH:mm"));
                });
            }
        }
        if (matchingSlot) {
            setSelectedTimeSlot(matchingSlot.slotId);
        }
        let parsedDate;
        if (newTime.includes("T")) {
            parsedDate = new Date(newTime);
        }
        else {
            const [datePart, ...timeParts] = newTime.split(" ");
            const timeStr = timeParts.join(" ");
            const [year, month, day] = datePart.split("/").map(Number);
            const dateStr = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            parsedDate = new Date(`${dateStr} ${timeStr}`);
        }
        if (isNaN(parsedDate.getTime())) {
            return;
        }
        const formattedDateTime = format(parsedDate, "yyyy-MM-dd'T'HH:mm:ss");
        const slotId = matchingSlot ? matchingSlot.slotId : selectedTimeSlot;
        isTimeChangeInProgress.current = true;
        setTimeout(() => {
            navigate(`${location.pathname}?step=2&slot=${slotId}&time=${formattedDateTime}&male-count=${newMaleCount}&female-count=${newFemaleCount}`, { replace: true });
            setTimeout(() => {
                isTimeChangeInProgress.current = false;
            }, 100);
        }, 200);
    };
    const onConfirmTable = (payload) => {
        const finalPayload = payload || { ...selectedTable, time: selectedTime };
        setIsBottomSheetOpen(false);
        const queryParams = new URLSearchParams();
        if ((event === null || event === void 0 ? void 0 : event.has_sub_events) && (event === null || event === void 0 ? void 0 : event.sub_events)) {
            const subEvent = event.sub_events.find((se) => { var _a; return (_a = se.slots) === null || _a === void 0 ? void 0 : _a.some((slot) => slot.id === selectedTimeSlot); });
            if (subEvent) {
                queryParams.set("sub_event", `${subEvent.name}_${subEvent.id}`);
            }
        }
        navigate(`/event/booking/confirm/table/${eventId}/${selectedTimeSlot}/${maleCount}-${femaleCount}-0?${queryParams.toString()}`, {
            state: { data: { selectedTable: finalPayload } },
        });
    };
    const isProceedDisabled = () => {
        if ((maleCount || femaleCount) && selectedTime && currentStep === 1)
            return false;
        return true;
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { w: "100%", h: "100%", px: 4, py: 16, children: [_jsx(Box, { py: 2, children: _jsx(FastTrackEntryInfoCard, { bookingCloseTime: event.booking_close_time }) }), currentStep === 1 ? (
                    // <Box w={"100%"} px={2}>
                    //   <Flex
                    //     border={"1px solid #363636"}
                    //     bg={"#1A1A1A"}
                    //     borderRadius={8}
                    //     p={4}
                    //     my={5}
                    //     gap={"20px"}
                    //     flexDir={"column"}
                    //     alignItems={"center"}
                    //     justifyContent={"center"}
                    //   >
                    //     <Text
                    //       color={"#FFFFFF"}
                    //       fontWeight={700}
                    //       fontSize={"14px"}
                    //       lineHeight={"20px"}
                    //       mr={"auto"}
                    //       mt={1}
                    //     >
                    //       How Many Are In?
                    //     </Text>
                    //     <Box w={"100%"} display="flex" flexDir="column" gap={4} mt={2}>
                    //       <PassCounterTable
                    //         initialValue={maleCount}
                    //         label="Male"
                    //         onChange={(value) => setMaleCount(value)}
                    //       />
                    //       <PassCounterTable
                    //         initialValue={femaleCount}
                    //         label="Female"
                    //         onChange={(value) => setFemaleCount(value)}
                    //       />
                    //     </Box>
                    //     <Box w={"full"} color="white" mt={2} rounded="xl">
                    //       <Text
                    //         fontSize="14px"
                    //         fontWeight="700"
                    //         mb={4}
                    //         mr={"auto"}
                    //         lineHeight={"20px"}
                    //       >
                    //         Lock In Your Spot
                    //       </Text>
                    //       <Box
                    //         w="full"
                    //         overflowX="auto"
                    //         css={{
                    //           "&::-webkit-scrollbar": { height: "0px" },
                    //         }}
                    //       >
                    //         <Flex gap={3} mb={3} w="max-content" px={1}>
                    //           {uniqueDates?.map((date) => {
                    //             const { day, dayNum, month } = formatDate(date);
                    //             const isActive = date === selectedDate;
                    //             return (
                    //               <Flex
                    //                 key={date}
                    //                 flexDir="column"
                    //                 align="center"
                    //                 justify="center"
                    //                 w="65px"
                    //                 h="80px"
                    //                 gap={"4px"}
                    //                 borderRadius={"8px"}
                    //                 cursor="pointer"
                    //                 bg={isActive ? "#8155FE" : "#1E1E1E"}
                    //                 borderColor={isActive ? "transparent" : "#4E4E4E"}
                    //                 _hover={{ bg: "purple.500" }}
                    //                 borderWidth={"1px"}
                    //                 onClick={() => {
                    //                   setSelectedDate(date);
                    //                   setSelectedTime(null);
                    //                 }}
                    //               >
                    //                 <Text
                    //                   fontSize="10px"
                    //                   fontWeight={"400"}
                    //                   color="gray.300"
                    //                 >
                    //                   {day.toUpperCase()}
                    //                 </Text>
                    //                 <Text fontSize="14px" fontWeight={"700"}>
                    //                   {dayNum}
                    //                 </Text>
                    //                 <Text fontSize="10px" fontWeight={"400"}>
                    //                   {month.toUpperCase()}
                    //                 </Text>
                    //               </Flex>
                    //             );
                    //           })}
                    //         </Flex>
                    //       </Box>
                    //       <Divider mt={4} mb={6} borderColor={"#2F2F2F"} />
                    //       <Text fontSize="12px" fontWeight={"400"} mb={5}>
                    //         Select Your Visiting Time
                    //       </Text>
                    //       {/* Time Slots */}
                    //       <Grid templateColumns="repeat(3, 1fr)" gap={3}>
                    //         {filteredSlots?.map((slot, idx) => {
                    //           const slotKey = `${slot.date} ${slot.time}`;
                    //           const isSelected = selectedTime === slotKey;
                    //           return (
                    //             <Box
                    //               key={idx}
                    //               bg={isSelected ? "#281A53" : "#1E1E1E"}
                    //               color={"white"}
                    //               p={3}
                    //               borderWidth="1px"
                    //               borderColor={isSelected ? "#6640D2" : "#2F2F2F"}
                    //               textAlign="center"
                    //               borderRadius="md"
                    //               cursor="pointer"
                    //               onClick={() => {
                    //                 setSelectedTime(slotKey);
                    //                 setSelectedTimeSlot(slot.slotId);
                    //               }}
                    //             >
                    //               <Text fontSize={"12px"} fontWeight={400}>
                    //                 {slot.time}
                    //               </Text>
                    //             </Box>
                    //           );
                    //         })}
                    //       </Grid>
                    //     </Box>
                    //   </Flex>
                    // </Box>
                    _jsx(PassSelectionCard, { maleCount: maleCount, femaleCount: femaleCount, setMaleCount: setMaleCount, setFemaleCount: setFemaleCount, uniqueDates: uniqueDates, selectedDate: selectedDate, setSelectedDate: setSelectedDate, selectedTime: selectedTime, setSelectedTime: setSelectedTime, setSelectedTimeSlot: setSelectedTimeSlot, filteredSlots: filteredSlots, formatDate: formatDate, shouldShake: shouldShakeCounters })) : (_jsxs(_Fragment, { children: [(event === null || event === void 0 ? void 0 : event.is_table_new_flow_enabled) ? (_jsx(TableArea, { pubId: (event === null || event === void 0 ? void 0 : event.pub_id) || "", time: selectedTimeSlot !== undefined
                                    ? (event === null || event === void 0 ? void 0 : event.has_sub_events)
                                        ? ((_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.sub_events) === null || _a === void 0 ? void 0 : _a.find((subEvent) => {
                                            var _a;
                                            return (_a = subEvent.slots) === null || _a === void 0 ? void 0 : _a.some((slot) => slot.id === selectedTimeSlot);
                                        })) === null || _b === void 0 ? void 0 : _b.slots) === null || _c === void 0 ? void 0 : _c.find((slot) => slot.id === selectedTimeSlot))
                                            ? format(new Date(selectedTime), "yyyy-MM-dd'T'HH:mm:ss")
                                            : undefined
                                        : ((_d = event === null || event === void 0 ? void 0 : event.direct_slots) === null || _d === void 0 ? void 0 : _d.find((slot) => slot.id === selectedTimeSlot))
                                            ? format(new Date(selectedTime), "yyyy-MM-dd'T'HH:mm:ss")
                                            : undefined
                                    : undefined, peopleCount: maleCount + femaleCount, selectedTable: selectedTable, setSelectedTable: handleTableSelect, femaleCount: femaleCount, maleCount: maleCount, timeSlots: timeSlots, onTimeChange: handleTimeChange })) : (_jsx(TableAreaOld, { pubId: (event === null || event === void 0 ? void 0 : event.pub_id) || "", time: selectedTimeSlot !== undefined
                                    ? (event === null || event === void 0 ? void 0 : event.has_sub_events)
                                        ? ((_g = (_f = (_e = event === null || event === void 0 ? void 0 : event.sub_events) === null || _e === void 0 ? void 0 : _e.find((subEvent) => {
                                            var _a;
                                            return (_a = subEvent.slots) === null || _a === void 0 ? void 0 : _a.some((slot) => slot.id === selectedTimeSlot);
                                        })) === null || _f === void 0 ? void 0 : _f.slots) === null || _g === void 0 ? void 0 : _g.find((slot) => slot.id === selectedTimeSlot))
                                            ? format(new Date(selectedTime), "yyyy-MM-dd'T'HH:mm:ss")
                                            : undefined
                                        : ((_h = event === null || event === void 0 ? void 0 : event.direct_slots) === null || _h === void 0 ? void 0 : _h.find((slot) => slot.id === selectedTimeSlot))
                                            ? format(new Date(selectedTime), "yyyy-MM-dd'T'HH:mm:ss")
                                            : undefined
                                    : undefined, peopleCount: maleCount + femaleCount, selectedTable: selectedTable, setSelectedTable: handleTableSelectOld, femaleCount: femaleCount, maleCount: maleCount, timeSlots: timeSlots, onTimeChange: handleTimeChange })), _jsxs(Modal, { isOpen: isOpen, onClose: onClose, isCentered: true, children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { mx: 4, py: 2, bg: "linear-gradient(90deg, #252132 0%, #170156 100%)", children: [_jsx(ModalBody, { children: _jsxs(Flex, { direction: "column", align: "center", justify: "center", children: [_jsx(Img, { borderRadius: "50%", src: `${IMG_URL}/icons/zillout-dollar.svg`, alt: "Popup Image" }), _jsx(Text, { mt: 2, fontWeight: "500", fontSize: "10px", color: "#FFFFFF", textAlign: "center", children: "Amount will be fully redeemable for food & drinks at the venue." })] }) }), _jsx(ModalFooter, { justifyContent: "center", children: _jsx(Button, { p: "12px 25px", bgColor: "#8155FE", color: "#FFFFFF", onClick: onClose, fontSize: "12px", fontWeight: 400, gap: "8px", children: "Ok" }) })] })] })] }))] }), currentStep === 1 && (_jsx(Box, { position: "fixed", left: [0, 0, 0, "calc((100% - 400px)/ 2)"], bottom: 0, w: ["100%", "100%", "100%", "400px"], px: 4, pb: 4, opacity: showButtonAnimation && (maleCount || femaleCount) && selectedTime
                    ? 0
                    : 1, transition: "opacity 0.4s ease-in", children: _jsxs(Flex, { as: Button, variant: "solid", colorScheme: "purple", w: "100%", bg: "#8155FE", boxShadow: "0px 33px 30px 14px rgba(0,0,0,0.8)", justifyContent: "space-between", py: 5, px: 6, borderRadius: 10, color: "white", alignItems: "center", opacity: isProceedDisabled() ? 0.8 : 1, onClick: () => {
                        if (isProceedDisabled()) {
                            // Trigger shake animation on counter buttons
                            setShouldShakeCounters(true);
                            setTimeout(() => setShouldShakeCounters(false), 1500);
                            return;
                        }
                        if (+((event === null || event === void 0 ? void 0 : event.pub_id) || "") === 303 && !femaleCount) {
                            customToast({
                                title: "Only stag booking not allowed",
                                status: "warning",
                            });
                        }
                        else
                            onNextStep();
                    }, children: [_jsx(Text, { fontSize: "sm", fontWeight: 400, children: "Select Table" }), _jsx(Icon, { as: HiOutlineArrowNarrowRight, boxSize: 6 })] }) })), selectedTable && (_jsx(ResponsiveModal, { isOpen: isBottomSheetOpen, onClose: () => {
                    setSelectedTable(null);
                    setIsBottomSheetOpen(false);
                    setRequirementMessage("");
                }, paramKey: "table-booking-modal", header: "", showCloseButton: false, bg: "#212121", color: "white", size: "md", children: _jsxs(Box, { py: 3, px: 4, mb: 4, children: [requirementMessage && (_jsxs(_Fragment, { children: [_jsx(Box, { bg: "#282828", p: 3, mb: 3, borderRadius: "lg", w: "100%", children: _jsxs(VStack, { spacing: 2, align: "center", children: [_jsxs(HStack, { spacing: 1, align: "center", children: [_jsx(Icon, { as: FaFemale, color: "white", boxSize: 4 }), _jsxs(Text, { fontSize: "sm", color: "white", children: ["x ", selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.minLadiesRequired] }), _jsx(Box, { width: "14px", height: "14px", borderRadius: "full", border: "1px solid red", display: "flex", alignItems: "center", justifyContent: "center", bg: "transparent", children: _jsx(Text, { fontSize: "10px", color: "red", fontWeight: "bold", children: "i" }) })] }), _jsx(Text, { color: "white", fontSize: "sm", textAlign: "center", children: requirementMessage })] }) }), ((_j = selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.perks) === null || _j === void 0 ? void 0 : _j.length) ? (_jsx(Flex, { gap: "8px", overflowX: "scroll", whiteSpace: "nowrap", justifyContent: "flex-start", alignItems: "center", w: "full", py: 2, css: {
                                        "&::-webkit-scrollbar": {
                                            height: "4px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "gray.600",
                                            borderRadius: "10px",
                                        },
                                        scrollBehavior: "smooth",
                                    }, direction: "row", children: (_k = selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.perks) === null || _k === void 0 ? void 0 : _k.map((perk, index) => (_jsxs(Flex, { align: "center", justify: "center", p: "8px 12px", bg: "#282828", borderRadius: "4px", minW: "140px", flexShrink: 0, textAlign: "center", gap: "6px", children: [_jsx(Box, { as: "span", mr: 2, children: tablePerksIcons[perk] ? (_jsx(Img, { height: "16px", width: "16px", src: `${IMG_URL}${tablePerksIcons[perk]}` })) : (_jsx(AtSignIcon, { height: "16px", width: "16px", color: "#9D9D9D" })) }), _jsx(Text, { fontSize: "10px", fontWeight: "400", color: "#FFFFFF", children: perk })] }, index))) })) : null] })), selectedTable && !isTableDisabled() && (_jsxs(Box, { bg: "#212121", color: "white", p: 4, maxW: "400px", borderRadius: "md", position: "relative", gap: "12px", children: [_jsx(Tag, { fontSize: "10px", fontWeight: "400", color: "#FFFFFF", position: "absolute", top: -10, right: 6, bgColor: "blue", zIndex: 10, children: `Only ${selectedTable.availableTables} Left` }), _jsx(Flex, { justifyContent: "center", alignItems: "center", mb: 2, children: _jsx(Text, { textAlign: "center", fontSize: "12px", fontWeight: 700, color: "#FFFFFF", children: `Book this table for ${selectedTable.price}. Fully redeemable on food, & drinks ${((_l = selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.perks) === null || _l === void 0 ? void 0 : _l.length)
                                            ? ", also enjoy exclusive add-ons like"
                                            : ""} ` }) }), ((_m = selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.perks) === null || _m === void 0 ? void 0 : _m.length) ? (_jsx(Flex, { gap: "8px", overflowX: "scroll", whiteSpace: "nowrap", justifyContent: "flex-start", alignItems: "center", w: "full", py: 2, css: {
                                        "&::-webkit-scrollbar": {
                                            height: "4px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "gray.600",
                                            borderRadius: "10px",
                                        },
                                        scrollBehavior: "smooth",
                                    }, direction: "row", children: (_o = selectedTable === null || selectedTable === void 0 ? void 0 : selectedTable.perks) === null || _o === void 0 ? void 0 : _o.map((perk, index) => (_jsxs(Flex, { align: "center", justify: "center", p: "8px 12px", bg: "#282828", borderRadius: "4px", minW: "140px", flexShrink: 0, textAlign: "center", gap: "6px", children: [_jsx(Box, { as: "span", mr: 2, children: tablePerksIcons[perk] ? (_jsx(Img, { height: "16px", width: "16px", src: `${IMG_URL}${tablePerksIcons[perk]}` })) : (_jsx(AtSignIcon, { height: "16px", width: "16px", color: "#9D9D9D" })) }), _jsx(Text, { fontSize: "10px", fontWeight: "400", color: "#FFFFFF", children: perk })] }, index))) })) : null, _jsx(Text, { mt: 4, fontSize: "12px", fontWeight: "500", color: "#FFFFFF", textAlign: "center", children: `${selectedTable.areaName} • ${selectedTable.tableType}` })] })), selectedTable && !isTableDisabled() && (_jsx(Button, { mb: 2, _hover: { textColor: "white" }, w: "100%", h: "38px", background: isButtonDisabled() ? "#5A5A5A" : "#8155FE", borderRadius: 10, textColor: "white", isDisabled: isButtonDisabled(), opacity: isButtonDisabled() ? 0.5 : 1, onClick: onConfirmTable, children: _jsxs(Flex, { w: "full", justify: "space-between", align: "center", children: [_jsx(Text, { fontSize: "12px", fontWeight: "500", color: "#FFFFFF", children: selectedTable.price !== 0 &&
                                            ((_p = event === null || event === void 0 ? void 0 : event.payment_modes) === null || _p === void 0 ? void 0 : _p.partial) &&
                                            ((_q = event === null || event === void 0 ? void 0 : event.payment_related_info) === null || _q === void 0 ? void 0 : _q.advance_amt_percentage) &&
                                            ((_r = event === null || event === void 0 ? void 0 : event.payment_related_info) === null || _r === void 0 ? void 0 : _r.advance_amt_percentage) <
                                                100 ? (_jsxs(_Fragment, { children: ["Pay just", " ", _jsxs("strong", { children: [event.payment_related_info.advance_amt_percentage, "%"] }), " ", "to confirm booking"] })) : (`Continue booking this table now`) }), !isButtonDisabled() && (_jsx(Image, { src: `${IMG_URL}/icons/right-arrow.png` }))] }) }))] }) }))] }));
}
